const ErrorIcon = (props) => (
  <svg
    fill="none"
    viewBox="0 0 24 25"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipRule="evenodd" fill="currentColor" fillRule="evenodd">
      <path d="m11.9998 8.92349c.2485 0 .45.20147.45.45v3.00001c0 .2485-.2015.45-.45.45s-.45-.2015-.45-.45v-3.00001c0-.24853.2015-.45.45-.45z" />
      <path d="m12.0007 5.97899c-.4799 0-1.0606.32934-1.5505 1.21273l-3.63595 6.53998c-.4563.823-.43679 1.4721-.19223 1.8887.24432.4163.80053.7491 1.74267.7491h3.63601c.0251 0 .0497.002.0737.006h3.5623c.9387 0 1.4954-.3326 1.7406-.7494.2453-.417.2658-1.066-.1902-1.8884l-3.6357-6.54561c-.4899-.88339-1.0708-1.2131-1.5507-1.2131zm-.0737 11.29051h-3.56231c-1.13986 0-2.05964-.4112-2.51883-1.1935-.45894-.7818-.37043-1.7857.18128-2.7807l3.63601-6.54004c.00007-.00013-.00008.00014 0 0 .57815-1.04237 1.40755-1.67627 2.33755-1.67627s1.7592.63351 2.3373 1.6759l1.764 3.174 1.8721 3.37221c.5521.9956.6387 1.9998.179 2.7813-.4598.7817-1.3791 1.1931-2.5164 1.1931h-3.636c-.0251 0-.0497-.0021-.0737-.006z" />
      <path d="m11.3965 14.1735c0-.3314.2686-.6.6-.6h.0054c.3313 0 .6.2686.6.6s-.2687.6-.6.6h-.0054c-.3314 0-.6-.2686-.6-.6z" />
    </g>
  </svg>
);

export default ErrorIcon;
